//@flow
export const loadConstants = {
  LOADING: "LOADING",
  ADD_LOADING: "ADD_LOADING",
  REMOVE_LOADING: "REMOVE_LOADING",
  CLEAR_LOADING: "CLEAR_LOADING"
};
